import React from 'react'
import CourseList from '../components/CourseList'


class Courses extends React.PureComponent {

    componentDidMount() {
      this.props.setCategory(this.props.match.params.category)
      this.props.showSubNav(true)

      if ( this.props.match.params.id !== undefined ) {
        this.props.showCoursePopup(this.props.match.params.id)
      } else {
        this.props.showCoursePopup(null)
      }

    }

    componentWillUnmount() {
      this.props.showSubNav(false)
    }

    componentDidUpdate() {
      if ( this.props.category !== this.props.match.params.category ) {
        this.props.setCategory(this.props.match.params.category)
      }
      if ( this.props.match.params.id !== this.props.courseID ) {
        this.props.showCoursePopup(this.props.match.params.id)
      }
    }

    render() {

      // Get the category from the URL
      const Category = this.props.match.params.category

      return (
        <div className="coursePageContainer">
          <CourseList
            localURL={this.props.localURL}
            loggedInInfo={this.props.loggedInInfo}
            viewState={this.props.viewState}
            jsonData={this.props.jsonData}
            category={Category}
            supported={this.props.supported}
            mobile={this.props.mobile}
            themeStyles={this.props.themeStyles} />
        </div>
      )

    }

}


export default Courses
